import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const FacetItemDto = t.type(
  {
    value: t.string,
    count: nullable(t.number),
  },
  'SearchRequest',
);

type FacetItemDto = t.TypeOf<typeof FacetItemDto>;
export { FacetItemDto };
